import { Action } from '@ngrx/store';
import { IRebalancedPayload } from '../../../models/plannedPortfolios';
import { IMPExportPayload } from '../../../models/modelPortfolios';
import { IModelPortfolio, IModelPortfolioPosition } from 'src/app/models/modelPortfolios';

export enum ModelPortfoliosActionTypes {
  UPDATE_MODEL_PORTFOLIO_POSITIONS_STATE = 'UPDATE_MODEL_PORTFOLIO_POSITIONS_STATE',
  DELETE_MODEL_PORTFOLIO_POSITION = 'DELETE_MODEL_PORTFOLIO_POSITION',
  DELETE_MODEL_PORTFOLIO_POSITION_RESET = 'DELETE_MODEL_PORTFOLIO_POSITION_RESET',
  SUBMIT_MODEL_PORTFOLIO = 'SUBMIT_MODEL_PORTFOLIO',
  SUBMIT_MODEL_PORTFOLIO_SUCCESS = 'SUBMIT_MODEL_PORTFOLIO_SUCCESS',
  DELETE_MODEL_PORTFOLIO_SUBSCRIPTION = 'DELETE_MODEL_PORTFOLIO_SUBSCRIPTION',
  DELETE_MODEL_PORTFOLIO = 'DELETE_MODEL_PORTFOLIO',
  DELETE_MODEL_PORTFOLIO_SUCCESS = 'DELETE_MODEL_PORTFOLIO_SUCCESS',
  RESET_DELETE_MODEL_PORTFOLIO = 'RESET_DELETE_MODEL_PORTFOLIO',
  RESET_SUBMIT_MODEL_PORTFOLIO = 'RESET_SUBMIT_MODEL_PORTFOLIO',
  GET_MODEL_PORTFOLIOS = 'GET_MODEL_PORTFOLIOS',
  GET_MODEL_PORTFOLIOS_SUCCESS = 'GET_MODEL_PORTFOLIOS_SUCCESS',
  SELECT_MODEL_PORTFOLIO = 'SELECT_MODEL_PORTFOLIO',
  RESET_SELECTED_MODEL_PORTFOLIO = 'RESET_SELECTED_MODEL_PORTFOLIO',
  MODEL_PORTFOLIOS_DATA_ERROR = 'MODEL_PORTFOLIOS_DATA_ERROR',
  MODEL_PORTFOLIO_POSITION_UPDATE_ERROR = 'MODEL_PORTFOLIO_POSITION_UPDATE_ERROR',
  SELECT_MODEL_PORTFOLIO_POSITION = 'SELECT_MODEL_PORTFOLIO_POSITION',
  APPLY_MODEL_PORTFOLIO_SUCCESS = 'APPLY_MODEL_PORTFOLIO_SUCCESS',
  MODEL_PORTFOLIO_DATA_ERROR = 'MODEL_PORTFOLIO_DATA_ERROR',
}

export class UpdateModelPortfolioPositionsState implements Action {
  readonly type = ModelPortfoliosActionTypes.UPDATE_MODEL_PORTFOLIO_POSITIONS_STATE;
  constructor(public payload: IModelPortfolio) { }
}
export class DeleteModelPortfolioPosition implements Action {
  readonly type = ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_POSITION;
  constructor(public payload: {
    modelPortfolio: IModelPortfolio,
    positionName: string
  }) { }
}
export class DeleteModelPortfolioPositionReset implements Action {
  readonly type = ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_POSITION_RESET;
}
export class SubmitModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO;
  constructor(public payload: IModelPortfolio) { }
}
export class DeleteModelPortfolioSubscription implements Action {
  readonly type = ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUBSCRIPTION;
  constructor(public payload: IModelPortfolio) { }
}
export class SubmitModelPortfolioSuccess implements Action {
  readonly type = ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO_SUCCESS;
  constructor(public payload: IModelPortfolio) { }
}
export class DeleteModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO;
  constructor(public payload: {
    modelPortfolioId: number,
    modelPortfolioName: string
  }) { }
}
export class DeleteModelPortfolioSuccess implements Action {
  readonly type = ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUCCESS;
  constructor(public payload: string) { }
}
export class ResetDeleteModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.RESET_DELETE_MODEL_PORTFOLIO;
}
export class GetModelPortfolios implements Action {
  readonly type = ModelPortfoliosActionTypes.GET_MODEL_PORTFOLIOS;
}
export class GetModelPortfoliosSuccess implements Action {
  readonly type = ModelPortfoliosActionTypes.GET_MODEL_PORTFOLIOS_SUCCESS;
  constructor(public payload: IModelPortfolio[]) { }
}
export class SelectModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.SELECT_MODEL_PORTFOLIO;
  constructor(public payload: IModelPortfolio) { }
}
export class ResetSelectedModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.RESET_SELECTED_MODEL_PORTFOLIO;
  constructor(public payload: IModelPortfolio) { }
}
export class ResetSubmitModelPortfolio implements Action {
  readonly type = ModelPortfoliosActionTypes.RESET_SUBMIT_MODEL_PORTFOLIO;
}
export class ModelPortfolioPositionUpdateError implements Action {
  readonly type = ModelPortfoliosActionTypes.MODEL_PORTFOLIO_POSITION_UPDATE_ERROR;
  constructor(public payload: string) { }
}
export class SelectModelPortfolioPosition implements Action {
  readonly type = ModelPortfoliosActionTypes.SELECT_MODEL_PORTFOLIO_POSITION;
  constructor(public payload: IModelPortfolioPosition) { }
}
export class ApplyModelPortfolioSuccess implements Action {
  readonly type = ModelPortfoliosActionTypes.APPLY_MODEL_PORTFOLIO_SUCCESS;
  constructor(public payload: IRebalancedPayload) { }
}
export class ModelPortfoliosDataError implements Action {
  readonly type = ModelPortfoliosActionTypes.MODEL_PORTFOLIOS_DATA_ERROR;
  constructor(public payload: string) { }
}
export class ModelPortfolioDataError implements Action {
  readonly type = ModelPortfoliosActionTypes.MODEL_PORTFOLIO_DATA_ERROR;
  constructor(public payload: string) { }
}

export type ModelPortfoliosActions = UpdateModelPortfolioPositionsState | DeleteModelPortfolioPosition | DeleteModelPortfolioPositionReset | SubmitModelPortfolio |
  SubmitModelPortfolioSuccess | DeleteModelPortfolioSubscription | DeleteModelPortfolio | DeleteModelPortfolioSuccess | ResetDeleteModelPortfolio | ResetSubmitModelPortfolio |
  SelectModelPortfolio | ResetSelectedModelPortfolio | ApplyModelPortfolioSuccess |
  GetModelPortfolios | GetModelPortfoliosSuccess | ModelPortfolioDataError | ModelPortfolioPositionUpdateError | SelectModelPortfolioPosition | ModelPortfoliosDataError;
